function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { cmsActions } from '../../../reducers/cms.reducer';
import { modalActions } from '../../../reducers/modal.reducer';
import Button from '../../common/Button.react';
import Label from '../../common/form/Label.react';
import SelectProjectIcon from '../../common/form/select/SelectProjectIcon.react';
import ModalHeader from '../../modal/ModalHeader.react';
var ArticleProjectIconsAdd = function ArticleProjectIconsAdd(_ref) {
  var articleID = _ref.articleID,
    articlesAction = _ref.articlesAction,
    hideModalAction = _ref.hideModalAction;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    iconID = _useState2[0],
    setIconID = _useState2[1];
  var isValid = function isValid() {
    return iconID.length > 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Add Icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Contact",
    required: true
  }), /*#__PURE__*/React.createElement(SelectProjectIcon, {
    value: iconID,
    onChange: function onChange(iconID) {
      return setIconID(iconID);
    },
    permission: "edit-pos-articles"
  }), /*#__PURE__*/React.createElement(Button, {
    label: 'Add',
    permission: "edit-pos-articles",
    onClick: function onClick() {
      articlesAction({
        formData: {
          articleID: articleID,
          iconID: iconID
        },
        method: 'put',
        route: 'project-icons'
      });
      hideModalAction();
    },
    width: "120px",
    disabled: !isValid()
  })));
};
var mdtp = {
  articlesAction: cmsActions.articles,
  hideModalAction: modalActions.hide
};
export default connect(null, mdtp)(ArticleProjectIconsAdd);